export const TRANSFORM_LOCALE: Record<string, string> = {
	en: 'en-GB',
};
